import _defineProperty from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-bottom: -8px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { Radio } from './Radio';
import { Flex } from '../grid/Grid';
var Wrapper = styled.div(_templateObject());
var ChildrenWrapper = styled(Flex).attrs({
  flexWrap: 'wrap'
})(_templateObject2());

var getOptions = function getOptions(options) {
  return options.map(function (option) {
    return typeof option === 'string' ? {
      label: option,
      value: option
    } : option;
  });
};

export var Group = function Group(_ref) {
  var name = _ref.name,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      options = _ref.options,
      children = _ref.children,
      itemStyle = _ref.itemStyle,
      itemsWrapperStyle = _ref.itemsWrapperStyle;

  var _useState = useState(value || defaultValue || undefined),
      _useState2 = _slicedToArray(_useState, 2),
      checkedValue = _useState2[0],
      setCheckedValue = _useState2[1];

  var onOptionChange = useCallback(function (e) {
    // if pass value, we do not modify checkedValue directly
    if (!value && e.target.value !== checkedValue) {
      setCheckedValue(e.target.value);
    }

    if (onChange && e.target.value !== checkedValue) {
      onChange(e.target.value);
    }
  }, [value, checkedValue, onChange]);

  if (value && value !== checkedValue) {
    setCheckedValue(value);
  }

  var childrenForRender = options && options.length > 0 ? getOptions(options).map(function (option) {
    return (
      /*#__PURE__*/
      React.createElement(Radio, _extends({
        key: option.value,
        name: name,
        disabled: option.disabled || disabled,
        value: option.value,
        checked: checkedValue === option.value,
        onChange: onOptionChange
      }, itemStyle), option.label)
    );
  }) : React.Children.map(children, function (child) {
    return (
      /*#__PURE__*/
      React.cloneElement(child, _objectSpread({
        name: name,
        key: child.props.value,
        checked: checkedValue === child.props.value,
        onChange: onOptionChange
      }, itemStyle))
    );
  });
  return (
    /*#__PURE__*/
    React.createElement(Wrapper, null,
    /*#__PURE__*/
    React.createElement(ChildrenWrapper, itemsWrapperStyle, childrenForRender))
  );
};
Group.defaultProps = {
  options: [],
  itemsWrapperStyle: {},
  itemStyle: {
    mr: '4px',
    mb: '8px'
  }
};